import * as React from 'react';
import { ArticleHeading4, InlineText2, ArticleParagraph3 } from '@cian/ui-kit';
import { IconProductSpecialLoanRate24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './BankItem.css';
import { IPromoBank } from '../../../../types/newbuilding/promos';

interface IBankItemProps {
  bank: IPromoBank;
  label?: string;
  onMortgageClick?(): void;
}

export function BankItem({ bank, label, onMortgageClick }: IBankItemProps) {
  return (
    <div className={styles['item']}>
      <div className={styles['logo']}>
        {bank.secondSquareImageUrl || bank.logoUrl ? (
          <img className={styles['logo-image']} src={bank.secondSquareImageUrl || bank.logoUrl} alt="" />
        ) : (
          <div className={styles['logo-icon']}>
            <IconProductSpecialLoanRate24 />
          </div>
        )}
      </div>
      <div className={styles['content']}>
        {label && <ArticleParagraph3 color="gray60_100">{label}</ArticleParagraph3>}
        <ArticleHeading4>{bank.name}</ArticleHeading4>
      </div>
      {bank.cianMortgagePartnerLink && (
        <a
          className={styles['link']}
          href={bank.cianMortgagePartnerLink}
          onClick={onMortgageClick}
          target="_blank"
          rel="noreferrer"
        >
          <InlineText2 color="primary_100">Партнер Циан.Ипотеки</InlineText2>
        </a>
      )}
    </div>
  );
}
